<template>
  <v-btn
    v-bind="$attrs"
    class="white--text"
    color="success"
    target="_blank"
    depressed
    :loading="loading"
    :disabled="disabled"
    @click="onClick"
  >
    <v-icon class="mr-2" small>
      mdi-download
    </v-icon>
    {{ $t('common.download') }}
  </v-btn>
</template>

<script>
export default {
  props: {
    query: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    actionName: {
      type: String,
      required: true,
    },
    fileName: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: false,
  }),

  methods: {
    async onClick() {
      this.loading = true;
      await this.$store.dispatch(this.actionName, {
        params: this.query,
        name: this.fileName,
      });
      this.loading = false;
    },
  },
};
</script>

<style></style>
